import { selector } from "./selector";
import { gSelector } from "../../../app/selector";
import * as form from "../../../app/form";
import { crud } from "../../../app/crud";
import { formFields, sentFormFields, lostTagFormFields } from "./form-fields";

let isClick = false

const createModalAction = function (e) {
    let $modal = e.data.modal;
    let $form = $modal.find('form');
    let url = '/customer/tags/add-tag';
    let urlMne = '/customer/tags/add-tag/mne';
    let urlHr = '/customer/tags/add-tag/hr';

    if(isClick){
        return
    }

    isClick = true

    form.removeErrorMessages($form, formFields);
    const userCountry = $(selector.country).val();

    switch (userCountry) {
        case 'HR':
            url = urlHr;
            while(sentFormFields.length > 0) {
                sentFormFields.pop();
            }

            sentFormFields.push({ field: 'tagType', selector: 'input[name="hr_tag_type"]:checked' });

            if ($(selector.hr.tagTypeGeaRadio).is(':checked')) {
                sentFormFields.push({ field: 'serialNumber', selector: '#hr_gea_container input[name="serialNumber"]' });
                sentFormFields.push({ field: 'serialNumber_confirmation', selector: '#hr_gea_container input[name="serialNumber_confirmation"]' });
            }

            if ($(selector.hr.tagTypeQFreeRadio).is(':checked')) {
                sentFormFields.push({ field: 'serialNumber', selector: '#hr_qfree_container input[name="serialNumber"]' });
                sentFormFields.push({ field: 'serialNumber_confirmation', selector: '#hr_qfree_container input[name="serialNumber_confirmation"]' });
            }

            break;
        case 'ME':
            url = urlMne;
            break;
    }

    crud.create(url, form.getFormData($form, sentFormFields))
        .done((jqXHR) => {
            $modal.find(gSelector.btn.modal.save).addClass('successfully')
            form.handleSuccessResponse($form, true, jqXHR)
        })
        .fail((jqXHR) => {
            isClick = false
            form.handleFailResponse($form, formFields, jqXHR)
        });
}

const addTagModal = (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();

    let $modal = $(selector.modal.add).modal('show');

    let $form = $modal.find('form');

    $modal.off('hide.bs.modal').on('hide.bs.modal', function (e) {
        form.removeErrorMessages($form, formFields);
        form.resetFormData($form, sentFormFields);
        if ($modal.find(gSelector.btn.modal.save).hasClass('successfully'))
        window.location.reload()
    });

    $modal.find(gSelector.btn.modal.save).off('click').on('click', { modal: $modal }, createModalAction);
}

const sendLostTagAction = function (e) {
    let $modal = e.data.modal;
    let serialNumber = e.data.serialNumber;
    let $form = $modal.find('form');
    let url = '/customer/tags/' + serialNumber + '/lost';
    let $submitButton = $modal.find(gSelector.btn.modal.save);
    form.removeErrorMessages($form, lostTagFormFields);
    crud.create(url)
        .done((jqXHR) => {
            $modal.find(gSelector.btn.modal.save).addClass('successfully')
            form.handleSuccessResponse($form, false, jqXHR)
            $submitButton.prop('disabled', true);
            setTimeout(function () {
                location.reload();
            }, 2000);
        })
        .fail((jqXHR) => form.handleFailResponse($form, lostTagFormFields, jqXHR.responseText));
}

const openLostTagModal = function (e) {
    e.preventDefault();

    const $modal = $(selector.modal.lostTag).modal('show');
    let $form = $modal.find('form');
    let serialNumber = $(e.target).data('tag');

    $modal.off('hide.bs.modal').on('hide.bs.modal', function (e) {
        form.removeErrorMessages($form, lostTagFormFields);

        if ($modal.find(gSelector.btn.modal.save).hasClass('successfully')) {
            window.location.reload();
        }
    });

    $modal.find(gSelector.btn.modal.save).off('click').on('click', { modal: $modal, serialNumber }, sendLostTagAction);
}

const openFoundTagModal = function (e) {
    const $modal = $(selector.modal.foundTag).modal('show');
    let $form = $modal.find('form');
    let serialNumber = $(e.target).data('tag');

    $modal.off('hide.bs.modal').on('hide.bs.modal', function (e) {
        form.removeErrorMessages($form, lostTagFormFields);
        if ($modal.find(gSelector.btn.modal.save).hasClass('successfully')) {
            window.location.reload();
        }
    });

    $modal.find(gSelector.btn.modal.save).off('click').on('click', { modal: $modal, serialNumber }, sendFoundTagAction);
}

const sendFoundTagAction = function (e) {
    let $modal = e.data.modal;
    let serialNumber = e.data.serialNumber;
    let $form = $modal.find('form');
    let url = '/customer/tags/' + serialNumber + '/found';
    let $submitButton = $modal.find(gSelector.btn.modal.save);
    form.removeErrorMessages($form, lostTagFormFields);
    crud.create(url)
        .done((jqXHR) => {
            $modal.find(gSelector.btn.modal.save).addClass('successfully')
            form.handleSuccessResponse($form, false, jqXHR);
            $submitButton.prop('disabled', true);
            setTimeout(function () {
                location.reload();
            }, 2000);
        })
        .fail((jqXHR) => form.handleFailResponse($form, lostTagFormFields, jqXHR.responseText));
}

const hrTagTypeChange = function (e) {
    if ($(selector.hr.tagTypeGeaRadio).is(':checked')) {
        $(selector.hr.tagTypeGeaContainer).show();
        $(selector.hr.tagTypeQFreeContainer).hide();
    } else if ($(selector.hr.tagTypeQFreeRadio).is(':checked')) {
        $(selector.hr.tagTypeGeaContainer).hide();
        $(selector.hr.tagTypeQFreeContainer).show();
    }
}

const openActivateTagModal = function (e) {
    console.log($(selector.modal.activateTag))
    const $modal = $(selector.modal.activateTag).modal('show');
    let $form = $modal.find('form');
    let serialNumber = $(e.target).data('tag');
    let country = $(e.target).data('country');

    $modal.off('hide.bs.modal').on('hide.bs.modal', function (e) {
        form.removeErrorMessages($form, lostTagFormFields);
        if ($modal.find(gSelector.btn.modal.save).hasClass('successfully')) {
            window.location.reload();
        }
    });

    $modal.find(gSelector.btn.modal.save).off('click').on('click', { modal: $modal, serialNumber, country }, sendTagActivate);
}

const sendTagActivate = function (e) {
    let $modal = e.data.modal;
    let serialNumber = e.data.serialNumber;
    let country = e.data.country;
    let $form = $modal.find('form');
    let url = '/customer/tags/' + serialNumber + '/activate/' + country;
    let $submitButton = $modal.find(gSelector.btn.modal.save);
    form.removeErrorMessages($form, lostTagFormFields);
    crud.create(url)
        .done((jqXHR) => {
            $modal.find(gSelector.btn.modal.save).addClass('successfully')
            form.handleSuccessResponse($form, false, jqXHR);
            $submitButton.prop('disabled', true);
            setTimeout(function () {
                location.reload();
            }, 2000);
        })
        .fail((jqXHR) => form.handleFailResponse($form, lostTagFormFields, jqXHR.responseText));
}

const openDeactivateTagModal = function (e) {
    console.log($(selector.modal.deactivateTag))
    const $modal = $(selector.modal.deactivateTag).modal('show');
    let $form = $modal.find('form');
    let serialNumber = $(e.target).data('tag');
    let country = $(e.target).data('country');

    $modal.off('hide.bs.modal').on('hide.bs.modal', function (e) {
        form.removeErrorMessages($form, lostTagFormFields);
        if ($modal.find(gSelector.btn.modal.save).hasClass('successfully')) {
            window.location.reload();
        }
    });

    $modal.find(gSelector.btn.modal.save).off('click').on('click', { modal: $modal, serialNumber, country }, sendTagDeactivate);
}

const sendTagDeactivate = function (e) {
    let $modal = e.data.modal;
    let serialNumber = e.data.serialNumber;
    let country = e.data.country;
    console.log(country)
    let $form = $modal.find('form');
    let url = '/customer/tags/' + serialNumber + '/deactivate/' + country;
    let $submitButton = $modal.find(gSelector.btn.modal.save);
    form.removeErrorMessages($form, lostTagFormFields);
    crud.create(url)
        .done((jqXHR) => {
            $modal.find(gSelector.btn.modal.save).addClass('successfully')
            form.handleSuccessResponse($form, false, jqXHR);
            $submitButton.prop('disabled', true);
            setTimeout(function () {
                location.reload();
            }, 2000);
        })
        .fail((jqXHR) => form.handleFailResponse($form, lostTagFormFields, jqXHR.responseText));
}

export { addTagModal, openLostTagModal, openFoundTagModal, hrTagTypeChange, openActivateTagModal,openDeactivateTagModal };
